module.exports = __webpack_public_path__ + "static/carusel-lab-bd03a4c58bb588258a992902a461aef6.webp";